import type {
  CoreBookingService,
  CoreBookingServicePayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Update a booking service by ID.
 *
 * @endpoint PUT /api/saas/me/bookings/{bookingId}/booking_services/{serviceId}
 * @scope saas
 * @see https://flecto.dev/api-17299848
 */

export async function updateBookingService(
  bookingId: ParameterID,
  serviceId: ParameterID,
  service: CoreBookingServicePayload
): Promise<CoreBookingService> {
  const response = await api.put(
    `/api/saas/me/bookings/${bookingId}/booking_services/${serviceId}`,
    service
  )

  return response.data.booking_service
}
